//./plugins/posthog.js
import posthog from "posthog-js";

export default {
  install(Vue) {
    const isDev = process.env.NODE_ENV === "development";

    const ph = posthog.init("phc_v35tOBfMfmkPSetLbr2qgpWWD7IPT1hEgYcyvY7F0X5", {
      api_host: "https://us.i.posthog.com",
      ui_host: "https://us.posthog.com",
      debug: isDev,
    });
    window.posthog = ph;
    Vue.prototype.$posthog = ph;
  },
};
